/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FlightObservedSegment } from './FlightObservedSegment';
import {
    FlightObservedSegmentFromJSON,
    FlightObservedSegmentFromJSONTyped,
    FlightObservedSegmentToJSON,
    FlightObservedSegmentToJSONTyped,
} from './FlightObservedSegment';

/**
 *
 * @export
 * @interface FlightObservedItinerary
 */
export interface FlightObservedItinerary {
    /**
     *
     * @type {Array<FlightObservedSegment>}
     * @memberof FlightObservedItinerary
     */
    segments: Array<FlightObservedSegment>;
}

/**
 * Check if a given object implements the FlightObservedItinerary interface.
 */
export function instanceOfFlightObservedItinerary(value: object): value is FlightObservedItinerary {
    if (!('segments' in value) || value['segments'] === undefined) return false;
    return true;
}

export function FlightObservedItineraryFromJSON(json: any): FlightObservedItinerary {
    return FlightObservedItineraryFromJSONTyped(json, false);
}

export function FlightObservedItineraryFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightObservedItinerary {
    if (json == null) {
        return json;
    }
    return {

        'segments': ((json['segments'] as Array<any>).map(FlightObservedSegmentFromJSON)),
    };
}

export function FlightObservedItineraryToJSON(json: any): FlightObservedItinerary {
    return FlightObservedItineraryToJSONTyped(json, false);
}

export function FlightObservedItineraryToJSONTyped(value?: FlightObservedItinerary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'segments': ((value['segments'] as Array<any>).map(FlightObservedSegmentToJSON)),
    };
}
